import fs from '@/components/atoms/Fieldset';

interface Props {
  id: string;
  name?: string;
  avatar?: string;
  onUpdate: (avatar: { avatar?: string }) => void;
  isUserAvatar?: boolean;
  readOnly?: boolean;
  label: string;
  recommendedHint: string;
  supportedHint: string;
}

export const AvatarUploadField = ({
  id,
  name,
  avatar,
  onUpdate,
  isUserAvatar,
  readOnly,
  label,
  recommendedHint,
  supportedHint,
}: Props) => (
  <div className="flex flex-col gap-1">
    <div className="flex flex-col items-center gap-4 rounded-md border-b border-border bg-muted pt-4 pb-6">
      <fs.Avatar
        id={id}
        label={label}
        name={name}
        avatar={avatar}
        isUserAvatar={isUserAvatar}
        onUpdate={onUpdate}
        readOnly={readOnly}
      />
      {!readOnly && (
        <label htmlFor={id} className="cursor-pointer text-sm font-medium text-primary">
          {label}
        </label>
      )}
    </div>
    <p className="px-1 text-sm leading-5 text-muted-foreground">
      {recommendedHint} {supportedHint}
    </p>
  </div>
);
